import {Component, Input} from '@angular/core';
import {Observable} from 'rxjs';
import {map, share} from 'rxjs/operators';

import {LocalizationService} from '../../../shared/localization/localization.service';
import {Request} from '../../../shared/workflow/workflow-v2.interface';

@Component({
  selector: 'gp-workflow-timeline',
  templateUrl: './workflow-timeline.component.html',
  styleUrls: ['./workflow-timeline.component.scss']
})
export class WorkflowTimelineComponent {

  @Input()
  public request: Request;
  public triggerDateChange$: Observable<number>;

  constructor(private localizationService: LocalizationService) {
    this.triggerDateChange$ = this.localizationService.changeDateFormatEvent.pipe(
      map(() => Math.random()),
      share()
    );
  }
}
